import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=1367073c&"
import script from "./UserManagement.js?vue&type=script&lang=js&"
export * from "./UserManagement.js?vue&type=script&lang=js&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=1367073c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports